<template>
    <div class="login-form">
      <div class="login-form__title">Авторизация</div>
      <b-form @submit.prevent="onSubmit">
        <b-form-group label="Адрес электронной почты:">
          <b-form-input v-model="email" type="email" required></b-form-input>
        </b-form-group>
  
        <b-form-group>
          <template #label>Пароль:</template>
          <b-input-group>
            <b-form-input v-model="password" :type="passwordType" autocomplete="off"></b-form-input>
            <b-input-group-append
              v-if="enterPassword"
              @click="toggleVisiblePassword"
              class="cursor-pointer"
              is-text
            >
              <b-icon scale="1.5" variant="secondary" :icon="iconType"></b-icon>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
  
        <b-overlay class="mt-5" :show="loading">
          <button
            :class="{ disable: disableButton }"
            type="submit"
            class="login-form__submit"
          >
            Войти
          </button>
        </b-overlay>
      </b-form>
  
      <div class="text-center mt-4">
        <div>
          <b-link @click="$emit('show-password-reset')" class="text-secondary">
            Забыли пароль?
          </b-link> | <b-link :to="'/agent-register'" class="text-primary">Регистрация для агентов »</b-link>
        </div>
      </div>
    </div>
</template>  

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
      visiblePassword: false,
      loading: false,
      error: false,
    };
  },

  computed: {
    ...mapGetters("auth", ["isUserLoaded", "isAuthenticated", "getUserRoles", "getTempLink"]),

    enterPassword() {
      return this.password.length > 0;
    },

    passwordType() {
      return this.visiblePassword ? "text" : "password";
    },

    iconType() {
      return this.visiblePassword ? "eye" : "eye-slash";
    },

    disableButton() {
      return !(!!this.email && !!this.password);
    },
  },
  methods: {
    ...mapActions("auth", ["AUTH_REQUEST"]),

    onSubmit() {
      this.loading = true;
      const { email, password } = this;
      this.AUTH_REQUEST({ email, password })
        .then(() => {
          if (this.getUserRoles.includes('client')) {
            this.$router.push("/orders");
          } else if (this.getUserRoles.includes('lead-observer')) {
            this.$router.push("/orders");
          } else {
            if (this.getTempLink) {
              this.$router.push(this.getTempLink);
            } else {
              this.$router.push("/dashboard");
            }
          }
          this.$toast.success("Вы в системе! Отличного дня ✨", {
            position: "top-center",
            timeout: 3000,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: true,
            draggablePercent: 1,
            showCloseButtonOnHover: true,
            hideProgressBar: true,
            closeButton: "button",
            icon: "fa fa-exclamation-triangle",
            rtl: false,
          });
          this.$nextTick(() => {
            if (Object.keys(this.$route.query).length) {
              this.checkQueryForOpenSidebar(Object.keys(this.$route.query));
            }
          })
        })
        .catch((error) => {
          let errorMessage = "Ошибка авторизации, попробуйте снова";
          
          if (error.response && error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          }

          this.$toast.error(errorMessage, {
            position: "top-center",
            timeout: 3000,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: true,
            draggablePercent: 1,
            showCloseButtonOnHover: true,
            hideProgressBar: true,
            closeButton: "button",
            icon: "fa fa-exclamation-triangle",
            rtl: false,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleVisiblePassword() {
      this.visiblePassword = !this.visiblePassword;
    },
    checkQueryForOpenSidebar(querys) {
      querys.forEach(query => {
        this.$root.$emit('bv::toggle::collapse', `sidebar-right-${query}`);
      })
    },
  },
};
</script>
